'use strict';

import angular from 'angular';
import ListController from './list.controller';

export default angular.module('onyxReadingRoomApp.jdOrder.list', [])
  .controller('JdOrderListController', ListController)
  .name;



// WEBPACK FOOTER //
// ./client/app/jdOrder/list/index.js